// extracted by mini-css-extract-plugin
export var dividerContainer = "_7q-0";
export var line = "_7q-1";